<template>
  <v-row no-gutters>
    <template>
      <div class="p-3">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col md="4" sm="12">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Cari" single-line
                  hide-details></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table :headers="headers" :search="search" :items="internshipData" item-key="name" sort-by="calories"
            class="elevation-1">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Verifikasi Pendaftaran</v-toolbar-title>
                <!-- <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="indigo darken-4 white--text" dark class="mb-2" v-bind="attrs" v-on="on">
                        Verifikasi massal
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="text-h5">Are you sure you want to delete this
                        item?</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text>Cancel</v-btn>
                        <v-btn color="blue darken-1" text>OK</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog> -->
              </v-toolbar>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip class="ma-2" small color="amber accent-1">
                <v-icon left>
                  mdi-timeline-clock
                </v-icon>
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon color="dark" class="mr-2" @click="onActionVerifyClick(item)">
                mdi-file-check
              </v-icon>
            </template>
            <template v-slot:no-data>
              Belum ada data
            </template>
          </v-data-table>
        </v-card>
      </div>
    </template>
  </v-row>
</template>
<script>
export default {
  data: () => ({
    search: null,
    dialog: false,
    dialogDelete: false,
    selected: [],
    limit: 10,
    offset: 0,
    count: 0,
    headers: [
      {
        text: 'Nama',
        align: 'start',
        value: 'name',
      },
      { text: 'NIM', value: 'no_induk' },
      { text: 'Tanggal daftar', value: 'created_at' },
      { text: 'Rencana mulai', value: 'rencana_mulai_kp' },


      { text: 'Perusahaan', value: 'perusahaan' },
      { text: 'Status', value: 'status' },


      { text: 'Actions', value: 'actions', sortable: false },
    ],
    internshipData: [],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  created() {
    this.getData();
    this.initialize()
  },
  // watch: {
  //   'search'(val){
  //     this.getData();
  //   }
  // },
  methods: {
    getData() {

      this.axios.get("/api/verifikasi/pendaftaran").then((res) => {
        this.internshipData = res.data.data.map(val => {
          val.rencana_mulai_kp = new Date(val.kp.tanggal_rencana_mulai_kp).toLocaleDateString('id-ID', { month: 'short', year: 'numeric', day: 'numeric' });
          val.created_at = new Date(val.kp.created_at).toLocaleDateString('id-ID', { month: 'short', year: 'numeric', day: 'numeric' });
          val.perusahaan = val.kp.perusahaan_tujuan;
          val.status = 'Menunggu verifikasi';
          return val;
        })
        // this.count = res.data.count;
      }).finally(() => console.log('final'));
    },
    initialize() {
    },
    onChangePagination(event) {
      this.limit = event.itemsPerPage;
      this.offset = event.itemsPerPage * (event.page - 1);
      this.getData();
    },
    onActionVerifyClick(item) {
      this.$router.push({ name: 'verify-read', query: { read: item.kp.id } })
    },

    close() {
      this.dialog = false
    },

  },
}
</script>